module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 29 29.4",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }